import "@xterm/xterm/css/xterm.css";
import "@fontsource-variable/mulish/index.css";
import "@fontsource-variable/mulish/wght-italic.css";
import "@fontsource-variable/playfair-display/index.css";
import "@fontsource-variable/playfair-display/wght-italic.css";
import "@papersflow/ui/theme.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { WorkspaceContextProvider } from "./state/WorkspaceContextProvider";
import { BackendProviders } from "./providers/BackendProviders";
import { initializeAppearancePreferences } from "./appearancePreferences";
import { ToastProvider } from "@papersflow/ui";
import { ComposerContextIngressProvider } from "./components/composerContextIngress";
import "./styles.css";

initializeAppearancePreferences();

if ("__TAURI_INTERNALS__" in globalThis) {
  document.documentElement.setAttribute("data-runtime", "desktop");
  if (navigator.platform.toLowerCase().includes("mac")) {
    document.documentElement.setAttribute("data-desktop-platform", "macos");
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 20_000, retry: 1, refetchOnWindowFocus: false },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <BackendProviders>
      <QueryClientProvider client={queryClient}>
        <ComposerContextIngressProvider>
          <WorkspaceContextProvider>
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
          </WorkspaceContextProvider>
        </ComposerContextIngressProvider>
      </QueryClientProvider>
    </BackendProviders>
  </StrictMode>,
);
